module.exports = __webpack_public_path__ + "img/upload-white.822b9e0d.svg";